<template>
  <div class="ifttt-tianmu-container">
    <TianMuVideoPlanLibrary 
      :model="temdevice"
      :PlanId="PlanId"
      :web-container="webContainer"
      :action-list="tianmuDynamicActionList"
      :show-mode="showMode"
      :is-edit-video-scene="isEditVideoScene"
      :only-scene-no-list="onlySceneNoList"
      :selected-scene-no="selectedSceneNo"
    />

    <div class="tianmu-bottom">
      <OppleButton
        @click="confirm()"
      >
        {{ $t('tianmu.sure') }}
      </OppleButton>
    </div>
  </div>
</template>
<script>
import { GetTianMuChildDeviceList,GetMainDeviceByAuxiliary } from '@/axios/IDevice.js'
import { FindScene } from '@/axios/IScene.js';
import TianMuVideoPlanLibrary from '@/components/OppleDeviceTianMu/TianMuVideoPlanLibrary.vue'
import { APP_SHOW_MODE_ENUM } from '@/utils/enums'
import OppleButton from '@/components/Base/OppleButton/index.vue'


export default {
  components: {
    TianMuVideoPlanLibrary,
    OppleButton
  },
  props: {
    TianmuVideoSceneNo:{
      type: Number,
      default: 0,
    },
    actionlist:{
      type: Array,
      default: () => [],
    },
    webContainer: {
      type: Object,
      default: () => null,
    },
    showMode:{
      type: Number,
      default: APP_SHOW_MODE_ENUM.DEVICE,
    },
    onlySceneNoList:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      temdevice:{},
      PlanId:'',
      tianmuDynamicActionList:[],
      APP_SHOW_MODE_ENUM,
      isEditVideoScene:false,
      selectedSceneNo:0
    }
  },
  watch:{
    TianmuVideoSceneNo:{
      handler(){
        this.requestDeviceAllInfo()
      },
      // immediate:true
    },
    actionlist:{
      handler(){
          this.filterAction()
      },
    }
  },
  mounted() {
    this.requestDeviceAllInfo()
    this.filterAction()
  },
  methods: {
    async handleTianMuInIfttt(VDeviceId){
      if(!VDeviceId) return
      const {Result,StatusCode } = await GetTianMuChildDeviceList({ VDeviceId })
      if (StatusCode == this.$store.state.rightStatusCode) {
        const { PlanId } = Result || ''
        return PlanId
      }
    },
    confirm(){
      if(!this.tianmuDynamicActionList)return

      this.$emit('sceneVideoConfirm',this.tianmuDynamicActionList)
    },
    setActionDefaultValue(sceneNo){
      if(!sceneNo)return
      this.tianmuDynamicActionList.forEach(actionItem => {
        actionItem.ischeck = true
        const Values = actionItem.Values
        Values.forEach(tem => {
          if(tem.IsShow && tem.ValueType === 'UIControl_TianMu_Video_Group'){
            tem.DefaultValue = sceneNo
          }
        });
      });
    },

    filterAction(){
      let matched = []
      this.actionlist.forEach(action => {
          const hasMatch = action.Values?.some(value => (value.ValueType === 'UIControl_TianMu_Video_Group'))
          if (hasMatch) {
            matched.push(action)
          }
        })
        this.tianmuDynamicActionList = matched
        this.setActionDefaultValue(this.selectedSceneNo)
    },

    async requestDeviceAllInfo() {
      try {
        const videoSceneNo = this.TianmuVideoSceneNo

        if(!videoSceneNo){
          return
        }

        const sceneRes = await FindScene({
            sceneNo:videoSceneNo
        })

        const childVDevice = sceneRes.Result.DeviceList[0]

        this.temdevice = childVDevice
        this.PlanId = this.handleTianMuInIfttt(childVDevice.VDeviceId).toString()

        //获取显示指定场景
        this.selectedSceneNo = videoSceneNo

        this.setActionDefaultValue(videoSceneNo)

        this.$emit('setSceneVideoDevice',this.temdevice)

      } catch (e) {}
    },
  },
}
</script>
<style lang="scss" scoped>
.ifttt-tianmu-container{
  padding-top: 50px;
}
.tianmu-bottom{
  text-align: right;
  padding: 20px 50px;
}
</style>
